// Calculate height of WP admin bar and store it as a css variable
window.addEventListener("load", function () {
    const wpadminbar = document.getElementById("wpadminbar");
    const header = document.querySelector("header.wp-block-template-part");
    if (wpadminbar) {
        const height = wpadminbar.clientHeight;
        document.documentElement.style.setProperty("--wpadminbar-height", `${height}px`);
    }
    if (header) {
        const height = header.clientHeight;
        document.documentElement.style.setProperty("--header-height", `${height}px`);
    }
});

// If the page has scrolled down more than 10px, add a 'has-scrolled' class to the body. Remove the class again when we scroll back up to within 10px of the top.
// This is useful for styling elements differently when the page has been scrolled.
function addHasScrolledClass() {
    window.scrollY > 10 ? document.body.classList.add("has-scrolled") : document.body.classList.remove("has-scrolled");
}
window.addEventListener("load", addHasScrolledClass);
window.addEventListener("scroll", addHasScrolledClass);

// document.addEventListener('DOMContentLoaded', function () {
// 	const menu = document.getElementById('primary-menu');
// 	const searchForm = document.querySelector('.masthead .search-form');
// 	const navToggle = document.getElementById('nav-toggle');

// 	// Mobile menu toggle
// 	navToggle.addEventListener('click', function () {
// 		const expanded = this.getAttribute('aria-expanded') === 'true' || false;
// 		this.setAttribute('aria-expanded', !expanded);
// 		this.classList.toggle('is-open');
// 		menu.classList.toggle('is-open');
// 	});

// 	// Sub-menu toggling
// 	document.querySelectorAll('#primary-menu .menu-item-has-children > a').forEach(parentLink => {
// 		parentLink.addEventListener('click', function (e) {
// 			e.preventDefault();

// 			// Close all other submenus
// 			document.querySelectorAll('#primary-menu .submenu-open').forEach(item => {
// 				if (item !== this.parentNode) {
// 					item.classList.remove('submenu-open');
// 				}
// 			});

// 			// Toggle this submenu
// 			this.parentNode.classList.toggle('submenu-open');
// 		});
// 	});

// 	// Global click handler to close open elements
// 	document.addEventListener('click', function (e) {
// 		const clickedInsideMenu = e.target.closest('#primary-menu');
// 		const clickedNavToggle = e.target.closest('#nav-toggle');

// 		// Close submenus if click outside menu
// 		if (!clickedInsideMenu) {
// 			document.querySelectorAll('#primary-menu .submenu-open').forEach(item => {
// 				item.classList.remove('submenu-open');
// 			});
// 		}

// 		// Close mobile menu if open and click outside
// 		if (!clickedInsideMenu && !clickedNavToggle && menu.classList.contains('is-open')) {
// 			menu.classList.remove('is-open');
// 			navToggle.classList.remove('is-open');
// 			navToggle.setAttribute('aria-expanded', 'false');
// 		}
// 	});
// });

// Analytics helpers

const NT_ANALYTICS_DEBUG = false;  // set to false to silence console

function ntLog(...args) {
    if (NT_ANALYTICS_DEBUG) console.log('[NT analytics]', ...args);
}

// Dispatch helper
function ntDispatch(name, detail = {}) {
    ntLog('event fired:', name, detail);
    window.dispatchEvent(new CustomEvent(name, { detail }));
}


(function () {

	// Emit analytics event for filter usage
	function emitYeargroupAnalytics(reason) {
		const enabledSlugs = itemInputs
			.filter(i => i.checked)
			.map(i => i.value);

		ntDispatch('nt:yeargroupFilterChange', {
			reason,
			enabledSlugs
		});
	}

	// Find the rendered yeargroup list
	const list = document.querySelector('.yeargroup-list');
	if (!list) return;

	// Collect individual year group checkboxes
	const itemInputs = Array.from(list.querySelectorAll('input.yeargroup-toggle'));

	// Use the server-rendered "All" checkbox (rendered in single.php)
	const allCheckbox = list.querySelector('#yeargroup-all');
	if (!allCheckbox) return; // nothing to do if template didn't include it

	// Articles to filter
	const articles = Array.from(document.querySelectorAll('.newsletter-story-block'));
	// TOC items to filter
	const tocItems = Array.from(document.querySelectorAll('.table-of-contents .toc-list li'));

	// Map TOC items to their target articles
	const tocMap = tocItems
		.map(item => {
			const sel = item.getAttribute('data-target');
			if (!sel) return null;
			const target = document.querySelector(sel);
			if (!target) return null;
			return { item, target };
		})
		.filter(Boolean);

	// ScrollSpy: highlight current TOC item
	// if (tocMap.length > 0) {
	// 	// Observer triggers when an article is meaningfully in view
	// 	const observer = new IntersectionObserver(
	// 		entries => {
	// 			entries.forEach(entry => {
	// 				if (entry.isIntersecting) {
	// 					const id = '#' + entry.target.id;

	// 					// Remove existing highlights
	// 					tocItems.forEach(i => i.classList.remove('current'));

	// 					// Highlight matching TOC entry
	// 					const match = tocMap.find(x => '#' + x.target.id === id);
	// 					if (match) {
	// 						match.item.classList.add('current');
	// 					}
	// 				}
	// 			});
	// 		},
	// 		{
	// 			root: null,
	// 			rootMargin: '0px 0px -60% 0px', 
	// 			threshold: 0
	// 		}
	// 	);

	// 	// Observe only visible stories (hidden ones won’t intersect anyway)
	// 	tocMap.forEach(({ target }) => observer.observe(target));
	// }

	// Cookie helpers
	const COOKIE_NAME = 'newsletter_yeargroups';
	function setCookie(name, value, days) {
		let expires = '';
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
	}
	function getCookie(name) {
		const match = document.cookie.split('; ').find(row => row.indexOf(name + '=') === 0);
		return match ? decodeURIComponent(match.split('=')[1]) : null;
	}

	// Update "All" to be checked only when every individual checkbox is checked
	function updateAllState() {
		allCheckbox.checked = itemInputs.length > 0 && itemInputs.every(cb => cb.checked);
		// Update warning whenever we recompute the overall state
		updateFilterWarning();
	}

	// Show the filter warning if ALL checkboxes are unchecked; hide it if at least one is checked.
	function updateFilterWarning() {
		const warning = document.getElementById('filter-warning');
		if (!warning) return;
		// Treat "no checkboxes" as *no warning* (don't show)
		const anyChecked = itemInputs.length > 0 && itemInputs.some(i => i.checked);
		warning.setAttribute('aria-hidden', String(anyChecked));
		if (anyChecked) {
			warning.classList.add('hidden');
		} else {
			warning.classList.remove('hidden');
		}
	}

	// Save current enabled slugs to cookie (1 year)
	function savePreferences() {
		const enabled = itemInputs.filter(i => i.checked).map(i => i.value);
		setCookie(COOKIE_NAME, JSON.stringify(enabled), 365);
	}

	// Restore preferences from cookie if present; otherwise leave defaults (all checked)
	function restorePreferences() {
		const raw = getCookie(COOKIE_NAME);
		if (!raw) {
			// no cookie -> leave defaults (inputs are checked in markup)
			updateAllState();
			return;
		}

		try {
			const enabled = JSON.parse(raw);
			if (!Array.isArray(enabled)) throw new Error('invalid');
			const enabledSet = new Set(enabled.map(String));

			// Only set checkboxes that correspond to known slugs
			itemInputs.forEach(i => {
				i.checked = enabledSet.has(i.value);
			});
		} catch (e) {
			// malformed cookie -> ignore and leave defaults
		}
		updateAllState();
	}

	// Determine whether an article should be visible given enabled set
	function articleMatches(article, enabledSet) {
		const attr = article.getAttribute('data-yeargroups') || '';
		const groups = attr.split(/\s+/).filter(Boolean);
		if (groups.includes('all')) return true;
		return groups.some(g => enabledSet.has(g));
	}

	function tocItemMatches(item, enabledSet) {
		const attr = item.getAttribute('data-yeargroups') || '';
		const groups = attr.split(/\s+/).filter(Boolean);
		if (groups.includes('all')) return true;
		return groups.some(g => enabledSet.has(g));
	}

	function showTocItem(item) {
		item.classList.remove('hidden');
		item.setAttribute('aria-hidden', 'false');
	}

	function hideTocItem(item) {
		item.classList.add('hidden');
		item.setAttribute('aria-hidden', 'true');
	}

	// Show article with simple height + opacity transition
	function showArticle(article) {
		// If already visible, ensure aria-hidden cleared
		if (!article.classList.contains('is-filter-hidden')) {
			article.setAttribute('aria-hidden', 'false');
			return;
		}

		// Remove hidden class and animate to full height
		article.classList.remove('is-filter-hidden');
		article.classList.add('is-filter-showing');
		article.setAttribute('aria-hidden', 'false');

		// measure content height and animate max-height
		const target = article.scrollHeight;
		article.style.maxHeight = target + 24 + 'px';

		// cleanup after transition
		const onEnd = function (e) {
			if (e.propertyName !== 'max-height') return;
			article.style.maxHeight = '';
			article.classList.remove('is-filter-showing');
			article.removeEventListener('transitionend', onEnd);
		};
		article.addEventListener('transitionend', onEnd);
	}

	// Hide article with simple height + opacity transition
	function hideArticle(article) {
		// If already hidden, skip
		if (article.classList.contains('is-filter-hidden')) return;

		// Set current max-height to enable transition from current size
		const current = article.scrollHeight;
		article.style.maxHeight = current + 24 + 'px';

		// Force reflow before starting transition
		article.getBoundingClientRect();

		// Add hidden class then animate to 0
		article.classList.add('is-filter-hidden');
		article.style.maxHeight = '0px';

		// After transition, keep aria-hidden true and KEEP inline maxHeight at 0
		const onEnd = function (e) {
			if (e.propertyName !== 'max-height') return;
			article.setAttribute('aria-hidden', 'true');
			// KEEP article.style.maxHeight = '0px' to prevent layout reflow
			// Do NOT clear the inline maxHeight here.
			article.removeEventListener('transitionend', onEnd);
		};
		article.addEventListener('transitionend', onEnd);
	}

	// Apply current filters to all articles
	function applyFilters() {
		const enabled = new Set(itemInputs.filter(i => i.checked).map(i => i.value));

		// Articles
		articles.forEach(article => {
			if (articleMatches(article, enabled)) {
				showArticle(article);
			} else {
				hideArticle(article);
			}
		});

		// TOC Items
		tocItems.forEach(item => {
			if (tocItemMatches(item, enabled)) {
				showTocItem(item);
			} else {
				hideTocItem(item);
			}
		});
	}

	// Reset filter button
	const resetButton = document.querySelector('#reset-filter');
	if (resetButton) {
		resetButton.addEventListener('click', function () {
			// Turn all checkboxes on
			itemInputs.forEach(cb => cb.checked = true);
			allCheckbox.checked = true;

			// Update warning, save state, apply filters
			updateFilterWarning();
			savePreferences();
			applyFilters();
			emitYeargroupAnalytics('reset');
		});
	}

	// When "All" changes, toggle every individual checkbox to match and save & apply
	allCheckbox.addEventListener('change', function () {
		const makeOn = this.checked;
		itemInputs.forEach(i => {
			i.checked = makeOn;
		});
		// Update the warning now that we've toggled the inputs
		updateFilterWarning();
		savePreferences();
		applyFilters();
		emitYeargroupAnalytics('all-toggle');
	});

	// When any individual checkbox changes, update the "All" checkbox, save & apply
	itemInputs.forEach(i => {
		i.addEventListener('change', function () {
			updateAllState();
			savePreferences();
			applyFilters();
			emitYeargroupAnalytics('single-toggle');
		});
	});

	// Initialize from cookie (or defaults) then apply filters
	restorePreferences();
	applyFilters();
})();

// Modals 
import { google, outlook, office365, ics } from 'calendar-link';
document.addEventListener('DOMContentLoaded', () => {
    const subscribeModal = document.getElementById('subscribe-modal');
    const eventModal = document.getElementById('event-modal');

    const eventTitleEl = document.getElementById('event-modal-title');
    const eventDateEl = document.getElementById('event-modal-date');
    const eventButtonsEl = document.getElementById('event-modal-buttons');

    // Open Subscribe Modal
    document.addEventListener('click', e => {
        const btn = e.target.closest('[data-action="subscribe-to-calendar"]');
        if (!btn) return;
        e.preventDefault();
		ntDispatch('nt:subscribeCalendarModalOpen');
        subscribeModal.showModal();
    });

    // Open Event Modal
    document.addEventListener('click', e => {
        const btn = e.target.closest('[data-action="add-to-calendar"]');
        if (!btn) return;
        e.preventDefault();

		const anchorId = getArticleAnchor(btn);
		const eventUrl = anchorId ? buildEventUrl(anchorId) : window.location.href;

        eventTitleEl.innerHTML = btn.dataset.eventTitle;
        eventDateEl.innerHTML = btn.dataset.eventDateDisplay;

		const event = {
			title: btn.dataset.eventTitle,
			description: btn.dataset.eventDescription,
			location: btn.dataset.eventLocation,
			url: eventUrl,
			start: btn.dataset.startDatetime,
			end: btn.dataset.endDatetime,
		};

		
		// Set booleans seperately
		if (btn.dataset.allDay === 'true') {
			event.allDay = true;
		}
		
		if (event.allDay) { 
			googleUrl = buildGoogleAllDayEventUrl(event);
		} else {
			googleUrl = google(event);
		}
		// const googleUrl = google(event);
		const outlookUrl = outlook(event);
		const officeUrl = office365(event);
		// const yahooUrl = yahoo(event);
		const icalObject = ics(event); // Use this for iCal and Apple Calendar buttons

        eventButtonsEl.innerHTML = `
			<a href="${googleUrl}" target="_blank" class="button button-primary" data-provider="google">Google Calendar</a>
			<button class="button button-primary" data-provider="apple">Apple Calendar</button>
			<a href="${outlookUrl}" target="_blank" class="button button-primary" data-provider="outlook">Outlook.com / 365</a>
			<a href="${officeUrl}" target="_blank" class="button button-primary" data-provider="office">Office 365</a>
			<button class="button button-primary" data-provider="ics">Download .ics</button>
		`;
		// Track provider clicks
		eventButtonsEl.querySelectorAll('[data-provider]').forEach(btn => {
			btn.addEventListener('click', () => {
				ntDispatch('nt:eventAddToCalendarProvider', {
					provider: btn.getAttribute('data-provider'),
					title: event.title
				});
			});
		});

		function slugify(str) {
			return str
				.toLowerCase()
				.trim()
				.replace(/[^a-z0-9\s]/g, '')   // remove punctuation
				.replace(/\s+/g, '-')          // spaces -> hyphens
		}

		function buildGoogleAllDayEventUrl(event) {
			const start = event.start; // "YYYYMMDD"
			const end = event.end;     // "YYYYMMDD"

			// Google requires end = last day + 1
			const endExclusive = addOneDay(end);

			const params = new URLSearchParams({
				action: 'TEMPLATE',
				text: event.title || '',
				details: event.description || '',
				location: event.location || '',
				dates: `${start}/${endExclusive}`
			});

			return `https://calendar.google.com/calendar/render?${params.toString()}`;
		}

		function addOneDay(yyyymmdd) {
			const y = parseInt(yyyymmdd.slice(0, 4));
			const m = parseInt(yyyymmdd.slice(4, 6));
			const d = parseInt(yyyymmdd.slice(6, 8));

			const date = new Date(Date.UTC(y, m - 1, d));
			date.setUTCDate(date.getUTCDate() + 1);

			const y2 = date.getUTCFullYear();
			const m2 = String(date.getUTCMonth() + 1).padStart(2, '0');
			const d2 = String(date.getUTCDate()).padStart(2, '0');

			return `${y2}${m2}${d2}`;
		}

		function getGoogleUrl(event) {
			if (event.allDay) {
				return buildGoogleAllDayEventUrl(event);
			}

			// Use calendar-link's google() only for timed events
			return import_calendar_link_google(event); 
		}

		// Get the parent <article>'s ID
		function getArticleAnchor(el) {
			const article = el.closest('article');
			if (!article || !article.id) return null;
			return article.id;
		}

		// Build the event URL with anchor
		function buildEventUrl(anchorId) {
			const url = new URL(window.location.href);

			// Remove any existing hash
			url.hash = '';

			url.hash = anchorId;

			return url.toString();
		}

		function downloadIcs(content, eventTitle) {

    // Strip any data URL prefix
    const raw = content.replace(/^data:text\/calendar[^,]*,/i, '');

    // Decode %0D%0A etc.
    const decoded = decodeURIComponent(raw);

    const slug = slugify(eventTitle);
    const filename = `${slug}.ics`;

    const blob = new Blob([decoded], { type: 'text/calendar' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();

    URL.revokeObjectURL(url);

	document.addEventListener('click', e => {
		const providerBtn = e.target.closest('#subscribe-modal [data-provider]');
		if (!providerBtn) return;

		ntDispatch('nt:subscribeCalendarProvider', {
			provider: providerBtn.getAttribute('data-provider')
		});
	});
}


		const icsButtons = eventButtonsEl.querySelectorAll('[data-provider="ics"]');
		icsButtons.forEach(btn => btn.addEventListener('click', () => downloadIcs(icalObject,event.title)));
		const appleButtons = eventButtonsEl.querySelectorAll('[data-provider="apple"]');
		appleButtons.forEach(btn => btn.addEventListener('click', () => downloadIcs(icalObject,event.title)));
		// Analytics: modal opened
		ntDispatch('nt:eventAddToCalendarOpen', {
			title: event.title
		});
        eventModal.showModal();
    });

	document.addEventListener('click', e => {
		const btn = e.target.closest('[data-close-modal]');
		if (!btn) return;

		const dialog = btn.closest('dialog');
		if (dialog) dialog.close();
	});

    // Optional backdrop click handler for both dialogs
    function enableBackdropClose(dialog) {
        dialog.addEventListener('click', e => {
            const rect = dialog.getBoundingClientRect();
            const outside =
                e.clientX < rect.left ||
                e.clientX > rect.right ||
                e.clientY < rect.top ||
                e.clientY > rect.bottom;

            if (outside) dialog.close();
        });
    }

    enableBackdropClose(subscribeModal);
    enableBackdropClose(eventModal);
});

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('[data-action="copy-to-clipboard"]');

  buttons.forEach(button => {
    const originalLabel = button.innerHTML;

    button.addEventListener('click', async () => {
      const content = button.getAttribute('data-copy-content');

      try {
        await navigator.clipboard.writeText(content);
        button.innerHTML = 'Copied! <i class="fa-regular fa-check"></i>';
        button.disabled = true;

        setTimeout(() => {
          button.innerHTML = originalLabel;
          button.disabled = false;
        }, 3000);
      } catch (err) {
        console.error('Clipboard copy failed', err);
      }
    });
  });
});

document.addEventListener("click", e => {
    const btn = e.target.closest("button.toc-title");
    if (!btn) return;

    const list = btn.parentElement.querySelector(".toc-list");
    const expanded = btn.getAttribute("aria-expanded") === "true";

    btn.setAttribute("aria-expanded", !expanded);
    list.hidden = expanded; 
});
